import { Unidade } from './Unidade';
import { Fatura } from './fatura';
import { FaturamentoDetalhado } from './faturamento-detalhado';
import { DetalhamentoFatura } from './detalhamento-fatura';

export class FaturamentoDetalhadoCliente {
  faturamentoDetalhado: FaturamentoDetalhado;
  listaFaturamentoCliente: DetalhamentoFatura[];

  constructor(faturamentoDetalhadoCliente) {

    this.faturamentoDetalhado = new FaturamentoDetalhado(faturamentoDetalhadoCliente['faturamentoDetalhado']) || null;
    this.listaFaturamentoCliente = (faturamentoDetalhadoCliente['listaFaturamentoCliente'] || []).map(f=>new DetalhamentoFatura(f));
  }

}
